GP.GPMod('ActivityCarousel',function(self) {
    var vent   = null;
    var _util = null;
    var _log   = null;

    var data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util = self.app.Util;
            _log   = self.app.Util.log;
        }
    };

    // private variables
    var options = {
        my_duid: null,
        my_gender: null,
        my_membership: null,
        my_state_code: null,
        my_country_code: null,
        my_max_content_rating: null,
        newest_addition: null,
        buffer_state: [],
        buffer_country: [],
        buffer_global: [],
        buffer_state_max_len: 100,
        buffer_country_max_len: 50,
        buffer_global_max_len: 50,
        feed_interval_time: 1700,
        tooltip_hover_timeout: null,
        tooltip_hovered_users: [],
        tooltip_hovered_users_max_len: 50,
        send_viewed_feed: 0,
        viewed_feed_queue: [],
        // viewed_feed_queue_max_len: 10
        viewed_feed_queue_max_len: 5
    };

    var gui = {
        init: function() {
            this.$activity_feed_wrap = $('#activity-feed-carousel-wrap');
            this.$activity_feed = $('#activity-feed');
            this.$tooltip_wrap = $('#activity-feed-tooltip-wrap');
            this.$toggle_tab = $('#activity-feed-toggle');
            this.$main = $('#main');
        }
    };

    var apis = {
        send_feed_notification: function(send_data) {
            self.api.post('network.rtn', {
                data: send_data,
                success: function() {}
            });
        },
        mod_user_prefs: function(send_data) {
            self.api.post('user.mup', {
                data: send_data,
                success: function() {}
            });
        },
        get_on_top: function() {
            $.post('/members/user/get_on_top', {
                'process' : 1
            })
            .done(function(json) {
                // if (json.status) {

                // }
            });
        }
    };

    // private methods
    function _init() {
        options.my_duid               = GP.sdata.my_user.duid;
        options.my_gender             = GP.sdata.my_user.gender;
        options.my_membership         = GP.sdata.my_user.membership;
        options.my_state_code         = GP.sdata.my_user.state_code;
        options.my_country_code       = GP.sdata.my_user.country_code;
        options.send_viewed_feed      = GP.sdata.my_user.af_send_vf;
        options.my_max_content_rating = GP.sdata.my_user.max_content_rating;

        vent.on('ActivityCarousel:add', _append_buffer);

        vent.on('ActivityCarousel:show', _user_show);
        vent.on('ActivityCarousel:hide', _user_hide);

        vent.on('ActivityCarousel:get_streaming_thumbs', get_streaming_thumbs);

        vent.on('init_js:user:home', function() {
            // console.log('ActivityCarousel init_js:user:home called');

            if (gui.$activity_feed.is(':visible')) {
                $('body').addClass('activity-feed-shown');
                toggle_search_form_pos();
                if (parseInt(gui.$main.css('padding-top'),10) != 80) {
                    gui.$main.css('padding-top', 80);
                }
                _init_jcarousel();
            }

            get_streaming_thumbs();
        });
        vent.on('init_js:user:live_action', function() {
            // console.log('ActivityCarousel init_js:user:live_action called');
            get_streaming_thumbs();
        });

        vent.on('init_js:videochat:group', function() {
            MoshPit.remove_state('jump-page').add_state('jump-page');
        });

        vent.on('init_js:billing:add_credits', function() {
            MoshPit.remove_state('jump-page').add_state('jump-page');
        });
        vent.on('init_js:user:profile', function() {
            MoshPit.remove_state('jump-page').add_state('jump-page');
        });

        gui.$toggle_tab.click(function() {
            if (gui.$activity_feed_wrap.is(':hidden')) {
                _user_show();
            } else {
                _user_hide();
            }
        });

        // only init hover states for desktop
        if (!GP.sdata.is_mobile && !GP.sdata.is_tablet) {
            gui.$activity_feed.on('mouseenter', 'li', function(e) {
                clearTimeout(options.tooltip_hover_timeout);
                var feed_obj = $(e.target).closest('li');
                options.tooltip_hover_timeout = setTimeout(function() {
                    var location = (feed_obj.data('user').country_code == 'US') ? feed_obj.data('user').state_code+', '+feed_obj.data('user').country_code : feed_obj.data('user').country_code;
                    var pic = feed_obj.data('user')['max_content_' + options.my_max_content_rating + '_pic'];
                    var highlight = (feed_obj.data('user').exposure_package) ? 'red-highlight': '';
                    var streaming = (feed_obj.data('user').streaming) ? 'data-streaming="' + feed_obj.data('user').duid + '" ': '';
                    var streaming_overlay = (feed_obj.data('user').streaming) ? '<div class="live-overlay"><span>Live</span></div>' : '';
                    var username  = (feed_obj.data('user').short_name) ? feed_obj.data('user').short_name : feed_obj.data('user').username;
                    var content_id = (feed_obj.data('user').content_media_id) ? feed_obj.data('user').content_media_id : '';

                    var interests_overlay = '';
                    if (window._full_domain_name.match(/smokeandpoke\.com/i) && feed_obj.data('user').interests && feed_obj.data('user').interests.match(/WEED/)) {
                        interests_overlay = '<img src="' + cdn_domain +
                            '/images/interests-weed.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
                        streaming_overlay = '';
                    } else if (window._full_domain_name.match(/sexygamerz\.com/i) && feed_obj.data('user').interests && feed_obj.data('user').interests.match(/GAMES/)) {
                        interests_overlay = '<img src="' + cdn_domain +
                            '/images/interests-games.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
                        streaming_overlay = '';
                    } else if (window._full_domain_name.match(/wealthymen\.com/i) && feed_obj.data('user').income && feed_obj.data('user').income.match(/150/)) {
                        interests_overlay = '<img src="' + cdn_domain +
                            '/images/diamond_wealthymen.com.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
                        streaming_overlay = '';
                    } else if (window._full_domain_name.match(/richmen\.com/i) && feed_obj.data('user').income && feed_obj.data('user').income.match(/150/)) {
                        interests_overlay = '<img src="' + cdn_domain +
                            '/images/diamond_richmen.com.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
                        streaming_overlay = '';
                    }

                    if (options.my_max_content_rating == 'pg' || options.my_max_content_rating == 'pg13' || _bank_site) {
                        streaming = '';
                        streaming_overlay = '';
                    }

                    // make sure we're not using http:// explicitely
                    pic = _util.parse_carousel_pic(pic);

                    var tooltip =
                        '<div class="activity-feed-tooltip">'+
                            '<a href="/members/user/profile/?duid='+feed_obj.data('user').duid+'&content_id='+content_id+'">'+
                                '<img class="'+highlight+'" ' + streaming + ' src="'+pic+'">'+
                                '<p class="text_overflow username">'+username+'</p>'+
                                '<p>'+feed_obj.data('user').age+' / '+feed_obj.data('user').gender.substr(0,1)+' / '+location+'</p>'+
                                '<p>'+feed_obj.data('user').activity_feed_action+'</p>'+
                            '</a>'+streaming_overlay+interests_overlay+
                        '</div>';
                    $('#activity-feed-tooltip-wrap div').remove();
                    // this is tricky: 'activity-feed ul' is continually moving left which results in a negative left position
                    var tooltip_left = (feed_obj.position().left + $('#activity-feed ul').position().left) - 15;
                    $(tooltip).appendTo(gui.$tooltip_wrap).css('left', tooltip_left+'px');

                    if (options.my_membership == 'FREE') {
                        // accounting for the show/hide tab not being there
                        $('#activity-feed-tooltip-wrap .activity-feed-tooltip').css('top', '+=16');
                    }

                    _send_hovered_feed_notification(feed_obj.data('user').duid);

                }, 250);
            });
            gui.$activity_feed.on('mouseleave', 'li', function() {
                clearTimeout(options.tooltip_hover_timeout);
            });

            gui.$tooltip_wrap.on('mouseleave', '.activity-feed-tooltip', function() {
                $(this).remove();
                clearTimeout(options.tooltip_hover_timeout); // just to be safe
                gui.$activity_feed.jcarouselAutoscroll('start');
            });
        }

        if (gui.$activity_feed.is(':visible')) {
            $('body').addClass('activity-feed-shown');
            if (parseInt(gui.$main.css('padding-top'),10) != 80) {
                gui.$main.css('padding-top', 80);
            }
            toggle_search_form_pos();
            _init_jcarousel();
        }
    }

    var events = {
        init: function() {
            vent.on(self.moduleName+":setup_get_on_top_modal",events.setup_get_on_top_modal);
        },
        setup_get_on_top_modal: function() {
            $('.btn-purchase-get-on-top').on('click', apis.get_on_top);
        }
    };

    function _init_jcarousel() {
        // console.trace('init_jcarousel called');
        // this is split out from the other init function because IE10 is a bitch and complains when we init a hidden jcarousel
        gui.$activity_feed
            .jcarousel({
                'wrap': 'circular',
                'animation': {
                    'duration': options.feed_interval_time, // animation length
                    'easing': 'linear'
                }
            })
            .jcarouselAutoscroll({
                'interval': options.feed_interval_time, // time in between animations
                'autostart': gui.$activity_feed.is(':visible') ? true : false,
                'create': gui.$activity_feed
                    .bind('mouseenter', function() {
                        if (!GP.sdata.is_mobile && !GP.sdata.is_tablet) {
                            $(this).jcarouselAutoscroll('stop');
                        }
                    })
                    .bind('mouseleave', function() {
                        if (!GP.sdata.is_mobile && !GP.sdata.is_tablet) {
                            // if they quickly hover over the feed then back out before a tooltip pops
                            if (!$('#activity-feed-tooltip-wrap .activity-feed-tooltip').length) {
                                $(this).jcarouselAutoscroll('start');
                            }
                        }
                    })
            })
            .on('jcarousel:animateend', function(event, carousel) {
                _buffer_to_feed();
            });
    }

    function _validate_item(item) {
        // validate as much as we can before we even put this item into a buffer

        // make sure this user is seeking my gender
        if ($.inArray(options.my_gender, item.seeking) == -1) {
            //console.log('user is not seeking my gender, skipping');
            return false;
        }

        // smoke and poke users only see activity carousel users logging in with weed interests 50% of time
        if (window._full_domain_name.match(/smokeandpoke\.com/i) && Math.random() < 0.5 && !item.interests.match(/WEED/)) {
            return false;
        }

        // sexygamerz.com users only see activity carousel users logging in with video games interests 50% of time
        if (window._full_domain_name.match(/sexygamerz\.com/i) && Math.random() < 0.5 && !item.interests.match(/GAMES/)) {
            return false;
        }

        // bootycallz.com users only see activity carousel users logging in with race = black  50% of time
        if (window._full_domain_name.match(/bootycallz\.com/i) && Math.random() < 0.5 && !item.race.match(/BLACK/)) {
            return false;
        }

        // bbwz.com users only see activity carousel users logging in with body type = extra pounds 50% of time
        if (window._full_domain_name.match(/bbwz\.com/i) && Math.random() < 0.5 && !item.body_type.match(/A FEW EXTRA POUNDS/)) {
            return false;
        }


        // make sure this user is not me (shouldn't happen but check anyway)
        if (item.duid == options.my_duid) {
            //console.log('can\'t add myself to my own feed');
            return false;
        }

        return true;
    }

    function _buffer_to_feed() {
        if (options.buffer_state.length) {
            if (_append_feed(options.buffer_state[0])) {
                options.buffer_state.shift();
            }
        } else if (options.buffer_country.length) {
            if (_append_feed(options.buffer_country[0])) {
                options.buffer_country.shift();
            }
        } else if (options.buffer_global.length) {
            if (_append_feed(options.buffer_global[0])) {
                options.buffer_global.shift();
            }
        }
    }

    function _append_buffer(item) {
        // console.log('append_buffer(): %o', item);

        if(!_validate_item(item)) {
            return false;
        }

        // only US users have the feed targeted to the state level for now
        if ((options.my_country_code == 'US' && item.state_code == options.my_state_code) || item.streaming) {
            if (options.buffer_state.length < options.buffer_state_max_len) {
                options.buffer_state.push(item);
                //console.log('buffer_state.length: '+options.buffer_state.length);
                return true;
            } else if (item.streaming) {
                options.buffer_state.push(item);
            }
        } else if (item.country_code == options.my_country_code) {
            if (options.buffer_country.length < options.buffer_country_max_len) {
                options.buffer_country.push(item);
                //console.log('buffer_country.length: '+options.buffer_country.length);
                return true;
            }
        } else {
            if (options.buffer_global.length < options.buffer_global_max_len) {
                options.buffer_global.push(item);
                //console.log('buffer_global.length: '+options.buffer_global.length);
                return true;
            }
        }
        return false;
    }

    function _append_feed(item) {
        // console.log('append_feed(): %o', item);

        if (gui.$activity_feed.is('hidden')) {
            return false;
        }

        // make sure this item is not already in the feed
        var dupe = false;
        $.each($('#activity-feed li'), function() {
            if ($(this).data('user').duid == item.duid) {
                dupe = true;
                return true; // this just gets us out of $.each()
            }
        });
        if (dupe) {
            //console.log('user already in the feed, skipping');
            // return true so this item gets popped off the buffer or we will never advance past it
            return true;
        }

        var first = $('#activity-feed li').eq(0);

        // make sure this is not the item we just updated
        if (first.data('user').duid == options.newest_addition) {
            //console.log('can\'t update the item we just updated');
            return false;
        }

        // make sure this item is not visible
        if (gui.$activity_feed.jcarousel('visible').index(first) > 0) {
            //console.log('first item is still visible');
            return false;
        }


        var pic = item['max_content_' + GP.sdata.my_user.max_content_rating + '_pic'];

        // bail if we don't have a pic for whatever reason, or we have a placeholder pic (discreet, no pic etc...)
        if (!pic || _util.check_placeholder_pic(pic)) {
            //console.log('max_content_pic not found, skipping.');
            return false;
        }

        // make sure we're not using http:// explicitely
        pic = _util.parse_carousel_pic(pic);

        var highlight = (item.exposure_package) ? ' red-highlight ': '';
        var streaming = (item.streaming) ? 'data-streaming="' + item.duid + '" ': '';
        var streaming_overlay = (item.streaming) ? '<div class="live-overlay"><span>Live</span></div>' : '';
        var content_id = (item.content_id) ? item.content_id : '';

        var interests_overlay = '';
        if (window._full_domain_name.match(/smokeandpoke\.com/i) && item.interests && item.interests.match(/WEED/)) {
            interests_overlay = '<img src="' + cdn_domain +
                '/images/interests-weed.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
            streaming_overlay = '';
        } else if (window._full_domain_name.match(/sexygamerz\.com/i) && item.interests && item.interests.match(/GAMES/)) {
            interests_overlay = '<img src="' + cdn_domain +
                '/images/interests-games.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
            streaming_overlay = '';
        } else if (window._full_domain_name.match(/wealthymen\.com/i) && item.income && item.income.match(/150/)) {
            interests_overlay = '<img src="' + cdn_domain +
                '/images/diamond_wealthymen.com.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
            streaming_overlay = '';
        } else if (window._full_domain_name.match(/richmen\.com/i) && item.income && item.income.match(/150/)) {
            interests_overlay = '<img src="' + cdn_domain +
                '/images/diamond_richmen.com.png" style="position:absolute;bottom:2px;right:2px;width:20px;height:20px;">';
            streaming_overlay = '';
        }

        var flashing_text = '';
        var _mu = GP.sdata.my_user;
        if (item.new_user && typeof _mu.ab_variation != 'undefined' && _mu.ab_variation == 'flashing') {
            flashing_text = '<div class="flashing-text"><span>NEW</span></div>';
        }

        if (GP.sdata.my_user.max_content_rating == 'pg' || GP.sdata.my_user.max_content_rating == 'pg13' || _bank_site) {
            streaming = '';
            streaming_overlay = '';
        }

        var feed_content =
            '<div class="activity-feed-content">'+
                flashing_text+
                '<a href="/members/user/profile/?duid='+item.duid+'&content_id='+content_id+'">'+
                    '<img class="'+highlight+'" ' + streaming + ' src="'+pic+'">'+
                '</a>'+streaming_overlay+interests_overlay+
            '</div>';

        // add the new entry into the list
        first.data('user', item).html(feed_content);

        // keep track of the latest user we added
        options.newest_addition = item.duid;

        if (item.gender == 'MAN' && item.membership == 'FREE') {
            _send_viewed_feed_notification(item.duid);
        }

        //console.log('success, new feed item added');
        return true;
    }

    function _send_viewed_feed_notification(duid) {
        if (options.send_viewed_feed) {
            // batch send notifications so we don't overload the webserver with requests
            if (options.viewed_feed_queue.length < options.viewed_feed_queue_max_len) {
                options.viewed_feed_queue.push(duid);
                //console.log('viewed_feed_queue.length: '+options.viewed_feed_queue.length);
            } else {
                //console.log('batch send viewed_feed notifications');
                apis.send_feed_notification({ duid: options.viewed_feed_queue, type: 'vf' });
                options.viewed_feed_queue = [];
            }
        }
    }

    function _send_hovered_feed_notification(duid) {
        if ($.inArray(duid, options.tooltip_hovered_users) == -1) {
            apis.send_feed_notification({ duid: duid, type: 'hf' });

            if (options.tooltip_hovered_users.length >= options.tooltip_hovered_users_max_len) {
                options.tooltip_hovered_users = [];
            }
            options.tooltip_hovered_users.push(duid);
        }
    }

    // _show() & _hide() are for layout purposes only (billing pages)
    // they are not initiated by the user and will not change their cookie or user prefs
    // TODO: show/hide working probably doesn't work any more for jump pages
    function _show() {
        if (gui.$activity_feed_wrap.is(':hidden')) {
            gui.$main.css({ paddingTop: '+=80'});
            gui.$activity_feed_wrap.show();
            if (!gui.$activity_feed.attr('data-jcarousel')) {
                _init_jcarousel();
            } else {
                gui.$activity_feed.jcarouselAutoscroll('start');
            }
        }
        vent.trigger("Cometd:activity_carousel_subscribe");
    }

    function _hide() {
        if (gui.$activity_feed_wrap.is(':visible')) {
            gui.$main.animate({ paddingTop: '-=80'}, 'slow');
            gui.$activity_feed_wrap.slideUp('slow', function() {
                vent.trigger("Cometd:activity_carousel_unsubscribe");
                if (gui.$activity_feed.attr('data-jcarousel')) {
                    gui.$activity_feed.jcarouselAutoscroll('stop');
                }
            });
        }
    }

    // _user_show() & _user_hide() are bound to the feed toggle button are are initiated by the user
    function _user_show() {
        if (gui.$activity_feed_wrap.is(':hidden')) {
            gui.$main.animate({ paddingTop: '+=80'}, 'slow');
            $('body').addClass('activity-feed-shown');
            toggle_search_form_pos();
            gui.$activity_feed_wrap.slideDown('slow', function() {
                vent.trigger("Cometd:activity_carousel_subscribe");
                apis.mod_user_prefs({ 'pref' : 'p7', 'val' : 1 });

                // if jcarosel hasn't been init'd... do that now
                if (!gui.$activity_feed.attr('data-jcarousel')) {
                    _init_jcarousel();
                } else {
                    gui.$activity_feed.jcarouselAutoscroll('start');
                }
            });
        }
    }

    function _user_hide() {
        if (gui.$activity_feed_wrap.is(':visible')) {
            gui.$main.animate({ paddingTop: '-=80'}, 'slow');
            $('body').removeClass('activity-feed-shown');
            toggle_search_form_pos();
            gui.$activity_feed_wrap.slideUp('slow', function() {
                vent.trigger("Cometd:activity_carousel_unsubscribe");
                apis.mod_user_prefs({ 'pref' : 'p7', 'val' : 0 });

                if (gui.$activity_feed.attr('data-jcarousel')) {
                    gui.$activity_feed.jcarouselAutoscroll('stop');
                }
            });
        }
    }

    function toggle_search_form_pos() {
        // $('#search-form-wrap').toggleClass('lg:gp-top-[154px]');
    }

    // expose some functions
    self.init = function() {
        _init();
    };
    self.append = function(item) {
        _append_buffer(item);
    };
    self.show = function() {
        _show();
    };
    self.hide = function() {
        _hide();
    };
    self.user_hide = function() {
        _user_hide();
    };

    var streaming_thumbs = [];
    var streaming_thumbs_position = [];

    function get_streaming_thumbs() {
        var duids = [];
        streaming_thumbs_position = [];

        // do not show streaming thumbs if allow_x_rated-content is false
        if (_allow_x === true) {
            $('[data-streaming]').each(function(el) {
                duids.push($(this).data('streaming'));
            });

            // only make ajax request if we have users to get streaming thumbs for
            if (duids.length) {
                $.getJSON("/members/videochat/get_thumb/?duids=" + duids.join(), function (data) {
                    // if we get a logout_redirect, redirect the user to the logout page
                    if (data.hasOwnProperty('logout_redirect')) {
                        window.location.href = data.logout_redirect;
                        return;
                    }

                    streaming_thumbs = data;
                });
            }
        }
    }

    function set_streaming_thumbs() {
        var position = 0;

        $('[data-streaming]').each(function(el) {
            var uniqid = $(this).data('uniqid');
            if (!uniqid) {
                uniqid = Math.floor(Math.random()*9999999);
                $(this).data('uniqid', uniqid);
            }
            var duid = $(this).data('streaming');

            if (streaming_thumbs[duid] !== undefined) {
                if (streaming_thumbs_position[uniqid] === undefined || streaming_thumbs[$(this).data('streaming')][streaming_thumbs_position[uniqid]] === undefined) {
                    streaming_thumbs_position[uniqid] = 0;
                }
                var src = cdn_domain + streaming_thumbs[$(this).data('streaming')][streaming_thumbs_position[uniqid]];
                $(this).attr("src", src);

                streaming_thumbs_position[uniqid]++;
            }
        });
    }

    setInterval( set_streaming_thumbs, 500);
    setInterval( get_streaming_thumbs, 30000);

    this.addInitializer(function(){
        self.el  = 'activity-feed-wrap';
        self.$el = $('#' + self.el);

        data.init();
        gui.init();
        events.init();

        _init();

        get_streaming_thumbs();
    });
});
